import BasicAssets from './BasicAssets.vue'

export default BasicAssets
